// import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
// import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary
import img01 from "./../../../../assets/images/283.png";// Adjust the path as necessary

function Resources() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        MOSR
        <span className="text-orange-ef3e33 font-400"> Resources</span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          {/* <p className="text-primary-color mb-3">
            Services offered through the help desk (in person and virtually)
          </p> */}

          {/* <p className="text-primary-color mb-3 font-600">
            Our key areas are :
          </p> */}

          <ul class="green-star-ul">
            <li>Stevedore Safety video</li>
            <li>Ship repair and maintenance videos</li>
            <li>MOSH Newsletters</li>
          </ul>
        </div>
        <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div>
            {/* <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={img01} className="img-fluid rounded-1" alt="" />
            </div> */}
          </div>
        </div>
        <div className="accordion blackTab" id="blackTab">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabOne"
                aria-expanded="false"
                aria-controls="blackTabOne"
              >VIDEOS
              </button>
            </h2>
            <div
              id="blackTabOne"
              className="accordion-collapse collapse"
              data-bs-parent="#blackTab"
            >
              <div className="accordion-body">
                {/* <p className="mb-3">Stevedore inspections are conducted nationally in all the ports and applicable harbours. These are unannounced inspections involving observation of stevedore operations for unsafe acts and conditions, inspection of personal protective equipment, as well as inspection of mobile equipment, lifting gear and lifting plant. The inspections also involve inspection of safety documentations i.e. daily occupational safety inspection checklist, toolbox talk, crane inspection checklist, register of lifting appliances and loose gear etc.</p>
                 */}
                <div className="flex justify-center items-center h-screen bg-gray-100">
                  {/* <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/dQw4w9WgXcQ"  // Replace with your video ID
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe> */}

                  <iframe width="95%" height="480" src="https://www.youtube.com/embed/UwFEHiCJY_0" title="Sinking fishing vessel. Cape West Coast. South Africa 26 April 2024" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>

              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header">
              <button
                className="accordion-button "
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#blackTabTwo"
                aria-expanded="true"
                aria-controls="blackTabTwo"
              >Samsa English
              </button>
            </h2>
            <div
              id="blackTabTwo"
              className="accordion-collapse collapse show"
              data-bs-parent="#blackTab"
            >
              <div className="accordion-body">
                {/* <p className="mb-3">
                    Stevedore companies are audited biennially. The audit takes place at the company’s premises and companies are audited only for work on board vessels. The audit involves safety management documentation review i.e. baseline risk assessment, safe work procedures, training records etc, including auditing of machinery, mobile equipment and lifting gear that is used in stevedoring operations.
                  </p> */}
                  <div className="flex justify-center items-center h-screen bg-gray-100">
                  {/* <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube.com/embed/dQw4w9WgXcQ"  // Replace with your video ID
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe> */}

                  <iframe width="95%" height="480" src="https://www.youtube.com/embed/UwFEHiCJY_0" title="Sinking fishing vessel. Cape West Coast. South Africa 26 April 2024" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
              </div>
            </div>
          </div>



          {/* <p className="mb-4">
              To report any stevedore safety related concerns, kindly communicate with SAMSA via the SAMSA contact form or email <a href="mailto:nmjweni@samsa.org.za">nmjweni@samsa.org.za</a> or  contact the local SAMSA Office ( The office contact details are provided in this website).
            </p> */}
        </div>


      </div>
    </>
  );
}

export default Resources;